<template>
    <div class="layout-px-spacing dash_1">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Sales</span></li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>

            <ul class="navbar-nav flex-row ms-auto">
                <li class="nav-item more-dropdown">
                    <div class="dropdown custom-dropdown-icon">
                        <a href="javascript:;" class="nav-link dropdown-toggle" id="ddlSettings" data-bs-toggle="dropdown" aria-expanded="false">
                            <span>Settings</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="ddlSettings">
                            <li><a class="dropdown-item" data-value="Settings" href="javascript:void(0);">Settings</a></li>
                            <li><a class="dropdown-item" data-value="Mail" href="javascript:void(0);">Mail</a></li>
                            <li><a class="dropdown-item" data-value="Print" href="javascript:void(0);">Print</a></li>
                            <li><a class="dropdown-item" data-value="Download" href="javascript:void(0);">Download</a></li>
                            <li><a class="dropdown-item" data-value="Share" href="javascript:void(0);">Share</a></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">


 <!-- jobcards -->
  <Router-link to="#" 
    v-if="user_permissions.includes('can_view_jobcard_card')"
  class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">Jobcards</h3>
      </div>

    <div class="row g-3">
  <!-- Active -->
  <div class="col-md-6 col-sm-6">
    <div class="card shadow h-100 border-0" role="button"
         data-bs-toggle="modal" data-bs-target="#jobcards"
         @click="getJobCards('status_id=6')">
      <div class="card-body text-center">
        <h6 class="text-muted mb-2">Active</h6>
        <h4 class="text-primary mb-0">
          <v-f-number :start-val="0" :end-val="summary?.jobcard?.active ?? 0" :duration="3000" />
        </h4>
      </div>
    </div>
  </div>

  <!-- Completed -->
  <div class="col-md-6 col-sm-6">
    <div class="card shadow h-100 border-0" role="button"
         data-bs-toggle="modal" data-bs-target="#jobcards"
         @click="getJobCards('status_id=8')">
      <div class="card-body text-center">
        <h6 class="text-success mb-2">Completed</h6>
        <h4 class="text-success mb-0">
          <v-f-number :start-val="0" :end-val="summary?.jobcard?.completed ?? 0" :duration="3000" />
        </h4>
      </div>
    </div>
  </div>


</div>

    </div>
  </Router-link>
 
<!--  requisitions -->
  <Router-link to="/requisitions" 
    v-if="user_permissions.includes('can_view_material_requisition_card')"
  class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">Requisitions</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
             <!-- data-bs-toggle="modal" data-bs-target="#requisitions" -->
        <div class="col-6">
          <router-link to="/requisitions/all" >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Total</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.material_requisition?.total ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
              <!-- data-bs-toggle="modal" data-bs-target="#requisitions" -->
        <div 
        class="col-6">
        <router-link to="/requisitions/2" >
  <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.material_requisition?.pending ?? 0 " :duration="3000"/>
            </h4>
          </div>
        </router-link>
        
        </div>
      </div>
    </div>
  </Router-link>  
  <!-- lpo -->
 <Router-link to="#"
  v-if="user_permissions.includes('can_view_old_lpo_card')"
 class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">LPO.old : {{ summary?.lpo?.total }}</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <router-link to ="#"
           data-bs-toggle="modal" data-bs-target="#lpos"
           @click="getLpo('status_name=approved')"
          >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Approved</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.lpo?.approved ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
        <div 
         data-bs-toggle="modal" data-bs-target="#lpos"
         @click="getLpo('status_name=Unapproved')"
        class="col-6">
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.lpo?.unapproved ?? 0 " :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Router-link>
  <!-- new lpo  -->
    <Router-link to="#"
  v-if="user_permissions.includes('can_view_lpo_card')"
 class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">LPO : {{ summary?.new_lpo?.total }}</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <router-link :to="`/approval-chains/1`">
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Approved</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.new_lpo?.approved ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
                    <!-- data-bs-toggle="modal" data-bs-target="#approvals"
           @click="getApprovals(1,2)" -->
        <div 
        class="col-6">
        <router-link :to="`/approval-chains/1`">
         <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.new_lpo?.unapproved ?? 0 " :duration="3000"/>
            </h4>
          </div>
        </router-link>
 
        </div>
      </div>
    </div>
  </Router-link>

  <!-- budget amendment request -->
       <Router-link to="#"
  v-if="user_permissions.includes('can_view_lpo_card')"
 class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h5 class="text-dark">Budget Amendments : {{ summary?.budget_amendments?.total }}</h5>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <router-link to ="#"
          @click="getAmendments()"
          data-bs-toggle="modal" data-bs-target="#amendment-requests"
          >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Approved</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.budget_amendments?.approved ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
        <div 
               @click="getAmendments()"
                data-bs-toggle="modal" data-bs-target="#amendment-requests"
        class="col-6">
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.budget_amendments?.unapproved ?? 0 " :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Router-link>

<!-- grn -->
<Router-link to="#"
  v-if="user_permissions.includes('can_view_grn_card')"
class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">Goods Received Note</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6"
         data-bs-toggle="modal" data-bs-target="#grns"
         @click="getGrn('filled')"
        >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Filled</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.grn?.filled ?? 0" :duration="3000"/>
            </h4>
          </div>
        </div>

        <!-- Unapproved Card -->
        <div class="col-6"
         data-bs-toggle="modal" data-bs-target="#grns"
         @click="getGrn('pending')"
        >
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Pending</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.grn?.unapproved ?? 0" :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
</Router-link>
<!-- labour request -->
 <Router-link to="/labour-request"
   v-if="user_permissions.includes('can_view_labour_request_card')"
 class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">Labour requests</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Total</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.labour_request?.total ?? 0" :duration="3000"/>
            </h4>
          </div>
        </div>

        <!-- Unapproved Card -->
        <div class="col-6">
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.labour_request?.unapproved ?? 0" :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Router-link>

  <!--goods issue note  -->
    <Router-link to="#" 
    v-if="user_permissions.includes('can_view_delivery_note_card')"
  class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">Issue & Delivery Note</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <router-link to ="#"
          data-bs-toggle="modal" data-bs-target="#issue_notes"
          @click="getGins('status_id=9')"
          >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Issued </h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.gin?.total ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
        <div 
        class="col-6"
           data-bs-toggle="modal" data-bs-target="#delivery_notes"
          @click="getGdns()"
        >
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-success">Delivered</h6>
            <h4 class="text-success">
              <v-f-number :start-val="0" :end-val="summary?.gin?.delivered ?? 0 " :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Router-link>

  <!-- assets -->
 <Router-link to="/masters/machines" 
   v-if="user_permissions.includes('can_view_assets_card')"
 class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-4 ">
      <div class="mb-4">
        <h3 class="text-dark">Assets :  <v-f-number :start-val="0" :end-val="summary?.assets?.total_assets ?? 0" :duration="3000"/></h3>
      </div>

      <div class="row g-2">
        <!-- Machines -->
        <div class="col-4">
          <div class="card shadow border-start-primary p-2 text-center">
            <small class="text-dark text-truncate d-block">Machines</small>
            <h5>
              <v-f-number :start-val="0" :end-val="summary?.assets?.machines ?? 0" :duration="3000"/>
            </h5>
          </div>
        </div>

        <!-- Vehicles -->
        <div class="col-4">
          <div class="card shadow border-start-danger p-2 text-center">
            <small class="text-dark text-truncate d-block">Vehicles</small>
            <h5>
              <v-f-number :start-val="0" :end-val="summary?.assets?.vehicles ?? 0" :duration="3000"/>
            </h5>
          </div>
        </div>

        <!-- Supervision -->
        <div class="col-4">
          <div class="card shadow border-start-warning p-2 text-center">
            <small class="text-dark text-truncate d-block">Supervision</small>
            <h5>
              <v-f-number :start-val="0" :end-val="summary?.assets?.supervision ?? 0" :duration="3000"/>
            </h5>
          </div>
        </div>
      </div>
    </div>
</Router-link>

  <!-- New budgets -->
   <Router-link to="#" 
    v-if="user_permissions.includes('can_view_material_requisition_card')"
  class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
    <div class="card shadow-lg p-3">
      <div class="mb-3">
        <h3 class="text-dark">New Budgets</h3>
      </div>

      <div class="row">
        <!-- Total Card -->
        <div class="col-6">
          <router-link to ="#"
          data-bs-toggle="modal" data-bs-target="#budgetApprovals"
          @click="getBudgetsApproval()"
          >
          <div class="card shadow border-start-primary h-100 p-3">
            <h6 class="text-muted">Total</h6>
            <h4>
              <v-f-number :start-val="0" :end-val="summary?.budget_approvals?.all ?? 0" :duration="3000"/>
            </h4>
          </div>
          </router-link>

        </div>

        <!-- Unapproved Card -->
        <div
          data-bs-toggle="modal" data-bs-target="#budgetApprovals"
          @click="getBudgetsApproval('status_id=2')"
        class="col-6">
          <div class="card shadow border-start-danger h-100 p-3">
            <h6 class="text-danger">Unapproved</h6>
            <h4 class="text-danger">
              <v-f-number :start-val="0" :end-val="summary?.budget_approvals?.unapproved ?? 0" :duration="3000"/>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Router-link> 

        </div>
    </div>

    <!-- modal starts -->


<!-- Modal -->
<div class="modal fade mymodal" id="lpos" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" style="max-height: 95vh; display: flex; flex-direction: column;">
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ lpo_title }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close_lpo"
        @click="clearForm()"
        ></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="lpos" :columns="lpoColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                  <template
                  v-if="lpo_title === 'Requisitions'"
                  #awaits="props">
                    MD
                  </template> 
                   <template #check="props">
                  <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :checked="orders.includes(props.row.id)"
          @change="triggerOrder(props.row.id, $event.target.checked)"
        >
      </div>
                  
                  </template>
                    <template #approve="props">
                    <button class="btn btn-primary btn-sm p-2"
                    v-if="props.row.awaits === 'MD'"
                     @click="approveCheck(props.row.approval_id, 'managing_director')"
                    >
                   <div v-if="spinner === props.row.approval_id " class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
                                        </div>
                                        <div v-else>Approve</div>
                  </button>

                       <button class="btn btn-primary btn-sm p-2"
                    v-if="lpo_title === 'Requisitions'"
                     @click="approveRequest(props.row.id)"
                    >
                   <div v-if="spinner === props.row.id " class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
                                        </div>
                                        <div v-else>Approve</div>
                  </button>

                    <button class="btn btn-dark btn-sm p-2"
                    v-if="props.row.awaits === 'No one'"
                     @click="approveUncheck(props.row.approval_id, 'managing_director',props.row.id)"
                    >
                   <div v-if="spinner === props.row.approval_id " class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
                                        </div>
                                        <div v-else>Unapprove </div>
                  </button>
                    </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary"
         v-if="orders.length != 0 "
        >Approve</button>
      </div>
    </div>
  </div>
</div>

      <!-- grn modal starts  -->
       <div class="modal fade mymodal " id="grns" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ grn_title }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearModal()"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
        
          <div class="col-xl-6 col-lg-12 col-sm-12 layout-spacing">
              <div v-if="loading" v-html="tableShimmer()"></div>
            <div 
            v-else
            class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="grns" :columns="grnColumns" >
                          <template #select="props">
                    <svg
 v-if="props.row.id === selectedGrn.id"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg

                 @click="fillGrn(props.row)"
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>
          <div  class="col-xl-6  col-lg-12 col-sm-12 layout-spacing">
            <div v-if="loading" v-html="tableShimmer()"></div>
            <div 
            v-else class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="grnItems" :columns="grnItemColumns" >

                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearModal()">Close</button>
      </div>
    </div>
  </div>
</div>

       <!-- grn modal ends -->
        <!-- jobcard modal starts -->
                <div class="modal fade mymodal " id="jobcards" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">JobCards</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        @click="clearForm()"
        ></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-7 col-lg-12 col-sm-12 layout-spacing"
          >
            <div
            v-if="jobcards.length"
            class="panel p-0" >
              <div class="custom-table table3"   style="max-height: 95vh; overflow-y: auto;">
                <v-client-table :data="jobcards" :columns="jobcardColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>

                  <template #actions="props">
                    <svg
 v-if="props.row.id === selectedJobcard.id"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg

                 @click="getCostNote(props.row)"
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>
                  </template>
                </v-client-table>
              </div>
            </div>
            <div
            v-else v-html="tableShimmer()"
            ></div>
          </div>
                    <!-- cost note starts -->
                     <div
                      class="col-md-5"
                     v-if="costNote !== 'nothing' "
                     >
            <div 
            v-if="costNote "
            class="col-md-12">
            <div class="d-flex">
                                      <h4 class="mt-4">COST NOTE </h4>
<div class="ms-auto"
@click="closeModal()"
>
  <router-link :to="`/jobcard/${selectedJobcard?.id}/${selectedJobcard?.asset_id}`" class="btn btn-primary">
    View Jobcard
  </router-link>
</div>
            </div>
                      <ul class="list-group list-group-numbered shadow">
        <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Spares : {{ costNote?.spares?.toLocaleString() }}/=</div>
            </div>
        </li>

          <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Tyres : {{ costNote?.tyres?.toLocaleString() }}/=</div>
            </div>
        </li>
         <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Body Works : {{ costNote?.body_works?.toLocaleString() }}/=</div>
            </div>
        </li>

         <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Electrical Works : {{ costNote?.electrical_works?.toLocaleString() }}/=</div>
            </div>
        </li>

         <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Labour Cost : {{ costNote?.labour?.toLocaleString() }}/=</div>
            </div>
        </li>
          <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Engineering Works : {{ costNote?.engineering?.toLocaleString() }}/=</div>
            </div>
        </li>
          <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="">Additional Costs : {{ costNote?.additional?.toLocaleString() }}/=</div>
            </div>
        </li>
           <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto">
                <div class="fw-bold">Total Cost : {{ costNote?.total?.toLocaleString() }}/=</div>
            </div>
        </li>
    </ul>
            </div>
            <div
             class="col-md-12"
            v-else  v-html="rowShimmer()"></div>
                     </div>

                 <!-- cost note ends -->
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearForm()">Close</button>
      </div>
    </div>
  </div>
</div>
         <!-- jobcard modal ends -->
          <!-- requisition modal starts -->
                           <div class="modal fade mymodal " id="requisitions" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen "> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Requisitions</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        @click="closeModal()"
        ></button>
      </div>

 

 

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-4 col-lg-12 col-sm-12 layout-spacing">
            <div v-if="loading" v-html="tableShimmer()"></div>
            <div v-else class="panel p-0">
              <div class="custom-table table3" style="max-height: 600px; overflow-y: auto;">
                <v-client-table :data="requisitions" :columns="requisitionsColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                                 <template #actions="props">
                    <span
                    class="text-success"
                     @click="fillRequisition(props.row)"
                    >
<svg
 v-if="props.row.id === selectedRequisition"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>

                    </span>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>

          <div class="col-xl-8 col-lg-12 col-sm-12 layout-spacing">
                 <div 
      class="d-flex justify-content-center ">
        <div
        v-if="selectedRequisition && requisition_status === 'Unapproved'"
        class="btn-group" role="group" aria-label="Approve or Reject">
          <button class="btn btn-primary me-2"
          @click="approveRequisition()"
            :disabled="spinner==='approving'"
          >
         <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Approve</div>
        </button>
          <button class="btn btn-danger me-2"
          @click="rejection =! rejection "
          :disabled="spinner === 'rejecting'"
          >
            <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Reject</div>
          </button>

            <button class="btn btn-primary"
          @click="remarking =! remarking"
          :disabled="spinner === 'remarking'"
          >
            <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Remark</div>
          </button>
        </div>
        
      </div>


                <!--requisitio rejection form starts -->
             <div 
      v-if="rejection"
      class="row justify-content-center mt-1">
        <div class="col-12 col-md-10 col-lg-8">
          <form
          @submit.prevent="rejectRequisition()"
          class="d-flex flex-column flex-sm-row gap-2" style="gap: 0.5rem;">
        <input type="text" class="form-control flex-grow-1" placeholder="Enter Requisition Rejection remark" v-model="remark" required>
        <button type="submit" class="btn btn-primary">Send </button>
          </form>
        </div>
      </div>
           <!-- rejection form ends -->

                          <div 
     v-if="remarking"
      class="row justify-content-center mt-2">
                <div   class="col-12 col-md-10 col-lg-8">
          <form
          @submit.prevent="remarkRequisition(selectedRequisition)"
          class="d-flex flex-column flex-sm-row gap-2" style="gap: 0.5rem;">
        <input type="text" class="form-control flex-grow-1" placeholder="Enter Remark" v-model="remark" required>
        <button type="submit" class="btn btn-primary" :disabled="spinner ==='remarking'">
        <span v-if="spinner === 'remarking'" v-html="loadingSpinner()"></span>
          <span v-else>Send</span>
        </button>
          </form>
        </div>
</div>
      
      <table class="table table-bordered table-striped my-3">
        <thead class="table-light">
          <tr>
            <th>Requester</th>
            <th>Date</th>
            <th>Status</th>
            <th>Total Cost</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="selectedRequisition">
            <td>{{ requisitions.find(r => r.id === selectedRequisition)?.requester || 'N/A' }}</td>
            <td>{{ requisitions.find(r => r.id === selectedRequisition)?.date || 'N/A' }}</td>
            <td>
              <span class="badge"
                :class="'bg-' + (requisitions.find(r => r.id === selectedRequisition)?.status.color || 'secondary')">
                {{ requisitions.find(r => r.id === selectedRequisition)?.status.name || 'N/A' }}
              </span>
            </td>
              <td> {{ generalTotal.toLocaleString() }}/=</td>
            <td>{{ requisitions.find(r => r.id === selectedRequisition)?.remark || 'N/A' }}</td>
          </tr>
          <tr v-else>
            <td colspan="5" class="text-center text-muted">No requisition selected</td>
          </tr>
          
        </tbody>
      </table>


            <div class="panel p-5" style="max-height: 600px; overflow-y: auto;">
              <div class="custom-table table3" >
                <v-client-table :data="requisitionItems" :columns="requisitionItemColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>

    

                </v-client-table>
              </div>
                           <!-- attachment starts -->
                <embed v-if="attachment" :src="attachment" type="application/pdf" width="100%" height="600px" />
               <!-- attachment ends -->
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
         @click="closeModal()"
        >Close</button>
      </div>
    </div>
  </div>
</div>
           <!-- requisition modal ends -->
            <!-- approval modal starts -->
                                        <div class="modal fade mymodal " id="approvals" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen "> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ approval_title }} </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        @click="closeModal()"
        ></button>
      </div>

      <div 
      class="d-flex justify-content-center my-3">
        <div
        v-if="selectedRequisition && requisition_status === 'Unapproved'"
        class="btn-group" role="group" aria-label="Approve or Reject">
          <button class="btn btn-primary me-2"
          @click="approveRequisition()"
            :disabled="spinner==='approving'"
          >
         <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Approve</div>
        </button>
          <button class="btn btn-danger"
          @click="rejection =! rejection "
          :disabled="spinner === 'rejecting'"
          >
            <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Reject</div>
          </button>
        </div>
      </div>
       <div 
       v-if="generalTotal > 0"
       class="d-flex justify-content-center ">
        <h6 class="fw-bolder shadow p-2">Total : {{ generalTotal.toLocaleString() }}/=</h6>
      </div>
      <div 
      class="row justify-content-center mt-2">
        <div  v-if="rejection" class="col-12 col-md-10 col-lg-8">
          <form
          @submit.prevent="rejectAmendment()"
          class="d-flex flex-column flex-sm-row gap-2" style="gap: 0.5rem;">
        <input type="text" class="form-control flex-grow-1" placeholder="Enter Budget Rejection remark" v-model="remark" required>
        <button type="submit" class="btn btn-primary">Send </button>
          </form>
        </div>
 
      </div>


      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-4 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3" style="max-height: 600px; overflow-y: auto;">
                <v-client-table :data="approvals" :columns="approvalColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                                 <template #actions="props">
                    <span
                    class="text-success"
                     @click="fillApproval(props.row)"
                    >
<svg
 v-if="props.row.approval_item_id === selectedApproval"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>

                 <svg
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>

                    </span>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>

          <div class="col-xl-8 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-5" style="max-height: 600px; overflow-y: auto;">
                   <div 
      class="d-flex justify-content-center my-3">
        <div
        v-if="selectedApproval && approvals.find(a => a.approval_item_id === selectedApproval)?.awaits === 'Director'"
        class="btn-group" role="group" aria-label="Approve or Reject">
          <button class="btn btn-primary me-2"
          @click="approveLpo(selectedApproval)"
            :disabled="spinner==='approving'"
          >
         <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                    <div v-else>Approve</div>
        </button>
        </div>
      </div>
              <table class="table table-bordered table-striped mb-3">
                <thead class="table-light">
                  <tr>
                    <th>Requester</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Awaits</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="selectedApproval">
                      <td>
                      {{ approvals.find(a => a.approval_item_id === selectedApproval)?.requester || 'N/A' }}
                    </td>
                    <td>
                      {{ approvals.find(a => a.approval_item_id === selectedApproval)?.date || 'N/A' }}
                    </td>
                    <td>
                      <span class="badge"
                        :class="'bg-' + (approvals.find(a => a.approval_item_id === selectedApproval)?.status.color || 'secondary')">
                        {{ approvals.find(a => a.approval_item_id === selectedApproval)?.status.name || 'N/A' }}
                      </span>
                    </td>
                    <td>
                      <span v-if="approvals.find(a => a.approval_item_id === selectedApproval)?.status.name === 'Unapproved'">
                        {{ approvals.find(a => a.approval_item_id === selectedApproval)?.awaits || 'N/A' }} 
                      </span>
                      <span v-else>No One</span>
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="4" class="text-center text-muted">No approval selected</td>
                  </tr>
                </tbody>
              </table>
              <div class="custom-table table3" >
                <v-client-table :data="approvalItems" :columns="requisitionItemColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>

    

                </v-client-table>
              </div>
                           <!-- attachment starts -->
                             <img v-if="attachment" :src="attachment" class="img-fluid"/>
               <!-- attachment ends -->
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
         @click="closeModal()"
        >Close</button>
      </div>
    </div>
  </div>
</div>
             <!-- approval modal ends -->
            <!-- issue note starts -->
    <div class="modal fade mymodal " id="issue_notes" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-xl modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" style="max-height: 95vh; display: flex; flex-direction: column;">
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Good Issue Notes</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row">
          <div class="col-md-7">
        <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="gins" :columns="ginColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                  <template #actions="props">
                    <span
                    class="text-success"
                     @click="fillGin(props.row)"
                    >


<svg
 v-if="props.row.id === selectedGinId"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                      <svg
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>

                    </span>

                  </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
          </div>
          <div class="col-md-5">
              <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="ginItems" :columns="ginItemColumns" >
               
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>

      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
             <!-- issue note ends -->
              <!-- delivery note modal starts -->
                   <div class="modal fade mymodal " id="delivery_notes" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Good Delivery Notes</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row">
          <div class="col-md-5">
        <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="gdns" :columns="gdnColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                  <template #actions="props">
                    <span
                    class="text-success"
                     @click="fillGdn(props.row)"
                    >
<svg
 v-if="props.row.id === selectedGdnId"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>

                    </span>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
          </div>
          <div class="col-md-7">
              <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="gdnItems" :columns="gdnItemColumns" >
               
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>

      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
               <!-- delivery note modal ends -->

                  <!-- amendment request modal starts -->
   <div class="modal fade mymodal " id="amendment-requests" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" >
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Budget Amendment Request List</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        @click="clearAmendment()"
        ></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">


        <div class="row layout-top-spacing">
             <div class="col-xl-6 col-lg-12 col-sm-12 layout-spacing"
          >
                      <div
            v-if="loading" v-html="tableShimmer()"
            ></div>
            <div
             v-else            
            class="panel p-0" >
              <div class="custom-table table3" >
                <v-client-table :data="amendmenLists" :columns="amendmentListColumns" >
                    <template #status="props">
                                <span class="badge inv-status" :class="'badge-' + props.row.status.color">{{ props.row.status.name }} </span>
                    </template>

                     <template #select="props">
                    <svg
 v-if="props.row.id === selectedAmendment.id"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg

                 @click="selectAmendment(props.row)"
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>
                  </template>
                </v-client-table>
              </div>
            </div>

          </div>
          <div class="col-xl-6 col-lg-12 col-sm-12 layout-spacing"
          >
                  <!-- approval buttons starts -->
               <div 
      class="d-flex justify-content-center ">
        <div
        v-if="selectedAmendment && selectedAmendment.status.name === 'Unapproved'"
        class="btn-group mb-3" role="group" aria-label="Approve or Reject">
          <button class="btn btn-primary me-2"
          @click="approveBudget()"
            :disabled="spinner==='approving'"
          >
         <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Approve</div>
        </button>
          <button class="btn btn-danger"
          @click="rejection =! rejection "
          :disabled="spinner === 'rejecting'"
          >
            <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Reject</div>
          </button>
        </div>
      </div>
         <!-- approval buttons ends -->

          <div v-if="selectedAmendment?.status?.name === 'Rejected'" class="card border-danger shadow-sm my-3">
  <div class="card-header bg-danger text-white">
    <strong>Amendment Rejected</strong>
  </div>
  <div class="card-body text-start">
    <p><strong>Rejected By:</strong> {{ selectedAmendment.remarker }}</p>
    <p><strong>Reason:</strong> {{ selectedAmendment.remark }}</p>
  </div>
</div>

                      <div
            v-if="loading" v-html="tableShimmer()"
            ></div>
            <div
             v-else            
            class="panel p-0" >
              <div class="custom-table table3"  >
                <v-client-table :data="amendmentItems" :columns="amendmentListItemColumns" >
                </v-client-table>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
   <!-- amendment request modal ends -->

           <!-- budget approvals modal starts -->
  <div class="modal fade mymodal" id="budgetApprovals" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <!-- Fixed Header -->
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Budget Approvals</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" 
  @click="closeModal(); clearBudgetSelection();"></button>
        </div>

        <div class="d-flex justify-content-center my-3">
          <div v-if="selectedNewBudget && selectedNewBudget.status && selectedNewBudget.status.name === 'Unapproved'" class="btn-group" role="group" aria-label="Approve or Reject">
            <button class="btn btn-primary me-2" @click="approveNewBudget()" :disabled="spinner==='approving'">
              <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                <span class="sr-only"></span>
              </div>
              <div v-else>Approve</div>
            </button>
            <button class="btn btn-danger" @click="rejection =! rejection" :disabled="spinner === 'rejecting'">
              <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                <span class="sr-only"></span>
              </div>
              <div v-else>Reject</div>
            </button>
          </div>
        </div>

        <div v-if="rejection" class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <form @submit.prevent="rejectNewBudget()" class="d-flex flex-column flex-sm-row gap-2" style="gap: 0.5rem;">
              <input type="text" class="form-control flex-grow-1" placeholder="Enter Budget Rejection remark" v-model="remark" required>
              <button type="submit" class="btn btn-primary">Send</button>
            </form>
          </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <!-- Left Column - Budget List -->
               
              <div class="col-md-6">
                <div class="custom-table table3">
                  <div v-if="loading" v-html="tableShimmer()"></div>
                  <v-client-table v-else :data="BudgetsApproval" :columns="budgetColumns">
                    <template #status="props">
                      <span v-if="props.row && props.row.status" class="badge inv-status" :class="'badge-' + props.row.status.color">
                        {{ props.row.status.name }}
                      </span>
                    </template>
                    
                    <template #actions="props">
                      <span v-if="props.row" class="text-success" @click="selectBudget(props.row)">
                        <svg v-if="selectedNewBudget && props.row.id === selectedNewBudget.id" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
                          <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                          <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        </svg>
                      </span>
                    </template>
                  </v-client-table>
                </div>
              </div>

              <!-- Right Column - Budget Details -->
              <div class="col-md-6" v-if="selectedNewBudget">
                <div class="card mt-3 shadow p-3 border-0">
                  <div class="card-header py-3" :class="'bg-' + selectedNewBudget.status.color">
                    <h6 class="mb-0 text-white" >Budget: {{ selectedNewBudget.budget || 'N/A' }}</h6>
                  </div>
                  <div class="card-body py-3">
                    <p class="text-start text-dark mb-2"><strong>Requested by:</strong> {{ selectedNewBudget.requester || 'N/A' }}</p>
                    <p class="text-start text-dark mb-2"><strong>Description:</strong> {{ selectedNewBudget.description || 'N/A' }}</p>
                    <p class="text-start text-dark mb-0" v-if="selectedNewBudget.status?.name === 'Rejected'">
                      <strong>Rejection remark:</strong> {{ selectedNewBudget.remark || 'N/A' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Fixed Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" 
  @click="closeModal(); clearBudgetSelection();">Close</button>
        </div>
      </div>
    </div>
  </div>
           <!-- budget approvals modal ends -->


</template>

<script setup>
    import '@/assets/sass/widgets/widgets.scss';
    import { ref,inject } from 'vue';
    import { useMeta } from '@/composables/use-meta';
    import { VFNumber } from 'vue-animation-counter';
    import '@/assets/sass/scrollspyNav.scss';
    import '@/assets/sass/components/custom-counter.scss';
    useMeta({ title: 'Counter' });
    import axios from 'axios';
    const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL
    });



    const remarking = ref(false)
    const remarkRequisition = async (id) =>{
      spinner.value = "remarking"
      const payload = {
        remark : remark.value
      }
      try{
      const response  = await axiosInstance.put(`requisitions/${id}`,payload)
      showMessage("remark sent")
      // Push the remark into that specific requisition
      const req = requisitions.value.find(r => r.id === id);
      if (req) {
        req.remark = remark.value;
      }
      remarking.value = ''
      remark.value = ''
      }catch(error){
       showError(error.message)
       console.log(errir)
      }finally{
        spinner.value = ''
      }
    }
    const approveLpo = async(id)=>{
      spinner.value = 'approving'
      const payload = {
        status_id : 3
      }
      try{
      const response = await axiosInstance.put(`approval-lists/${id}`,payload)
      showMessage('Order Approved')
      fetchSummary()
      }catch(error){
        showError(error.message)
        console.log(error)
      }finally{
        spinner.value = false
      }

    }
    const clearModal = () =>{
      grns.value = ['']
      grnItems.value = ['']
      selectedGrn.value = ''
    }
const selectedGrn = ref('')
const grnItems = ref([])
const grnItemColumns = [ 'sno','item','description','unit','quantity','rate','cost'];
const fillGrn = (data) =>{
  selectedGrn.value = data
  grnItems.value = data.approval.items.map((item,index)=>({
    ...item,
    sno: index + 1,
    item: item.requisition_items.remark,
    description: item.requisition_items.description,
    unit : item.requisition_items.units,
    rate :  formatNumber(item.requisition_items.rate),
    cost : formatNumber(item.quantity * item.requisition_items.rate)
  }))
}

     const remark = ref('')
    const closeModal = ()=>{
        const modalEl = document.querySelector('.modal.show');
  if (modalEl) {
    const modalInstance = bootstrap.Modal.getInstance(modalEl);
    modalInstance?.hide();
  }



  document.body.classList.remove('modal-open');
  document.body.style.overflow = 'auto';
  document.body.style.paddingRight = '';
      generalTotal.value=0
      selectedRequisition.value = ''
      requisitionItems.value = []
      requisitions.value = []
      attachment.value= ''
      approvalItems.value = []
      selectedApproval.value = ''
    }

    const amendmentItems = ref([])
const amendmenLists = ref([])
const amendmentListColumns = [ 'sno','requester','budget','project','status','date','select'];
const amendmentListItemColumns = [ 'sno','description','unit','qty','qty2','sum' ,'rate','cost'];
const loading = ref(false)
  const getAmendments = async() =>{
  loading.value = true
 const response = await axiosInstance.get(`budget-amendments`)
 amendmenLists.value =  response.data.map((item, index) => ({
        ...item,
        sno: index + 1,
        requester:item.requester.name,
        budget:item.budget.name,
        project: item.budget.project.short_name
    }));

    loading.value = false
}
const selectedAmendment = ref('')
const selectAmendment = (data) =>{
   selectedAmendment.value = data
   amendmentItems.value = data.items.map((item, index) => ({
        ...item,
        sno: index + 1,
        qty: item.quantity,
        qty2 : item.quantity_2,
        sum : item.quantity * item.quantity_2,
        cost : (item.quantity * item.quantity_2 * item.rate).toLocaleString()+ '/=',
        rate : Number(item.rate).toLocaleString()+ '/='
    }));
}

const clearAmendment = () =>{
  amendmentItems.value = []
  selectedAmendment.value = ''
}

    const approveRequisition = async()=>{
     spinner.value = 'approving'
     const payload= {
        status_id:3
      }
      try{
        await axiosInstance.put(`requisitions/${selectedRequisition.value}`,payload)
              showMessage("requisition Approved")
              fetchSummary()
              getRequisitions('status_id=2')
              selectedRequisition.value = ''
              spinner.value = ''
              generalTotal.value = 0
              requisitionItems.value = []

      }catch(error){
          showError(error.message)
      }
    }

       const approveBudget = async()=>{
     spinner.value = 'approving'
     const payload= {
        status_id:3
      }
      try{
        await axiosInstance.post(`approve-amendment`,selectedAmendment.value)
        await axiosInstance.put(`budget-amendments/${selectedAmendment.value.id}`,payload)
              showMessage("Amendment Approved")
              fetchSummary()
              getAmendments()
              selectedAmendment.value = ''
              spinner.value = ''
              amendmentItems.value = []

      }catch(error){
          console.log(error)
          showError(error.message)
      }finally{
        spinner.value = ''
      }
    }

    const rejectRequisition = async ()=>{
      rejection.value=false
      spinner.value = 'rejecting'
      const payload= {
        status_id:4
      }
      const remarkPayload ={
        requisition_id: selectedRequisition.value,
        remarker_id:JSON.parse(localStorage.getItem("user")).id,
        remark:remark.value
      }

      try{

        await axiosInstance.post('requisition-remarks',remarkPayload)
        await axiosInstance.put(`requisitions/${selectedRequisition.value}`,payload)
              showMessage("requisition rejected")
              fetchSummary()
              getRequisitions('status_id=2')
              selectedRequisition.value = ''
              spinner.value = ''
              generalTotal.value = 0
              attachment.value = '',
              requisitionItems.value  = []
      }catch(error){
          showError(error.message)
          console.log(error)
      }
     
    }

        const rejectAmendment = async ()=>{
      rejection.value=false
      spinner.value = 'rejecting'
      const payload= {
        status_id:4
      }
      const remarkPayload ={
        budget_amendment_id: selectedAmendment.value.id,
        remarker_id:JSON.parse(localStorage.getItem("user")).id,
        description:remark.value
      }

      try{

        await axiosInstance.post('budget-amendment-remarks',remarkPayload)
        await axiosInstance.put(`budget-amendments/${selectedAmendment.value.id}`,payload)
              showMessage("Amendment rejected")
              fetchSummary()
              getAmendments()
              selectedAmendment.value = ''
              spinner.value = ''
              amendmentItems.value = []
      }catch(error){
          showError(error.message)
          console.log(error)
      }
     
    }

    const approveNewBudget = async () => {
  if (!selectedNewBudget.value?.id) {
    showError("Please select a budget to approve");
    return;
  }

  spinner.value = 'approving';
  const payload = {
    status_id: 3,
    approved_by: JSON.parse(localStorage.getItem("user")).id
  };

  try {
    await axiosInstance.put(`budget-approvals/${selectedNewBudget.value.id}`, payload);
    showMessage("Budget Approved");
    fetchSummary();
    getBudgetsApproval();
    selectedNewBudget.value = null;
  } catch (error) {
    console.error(error);
    showError(error.message);
  } finally {
    spinner.value = '';
  }
};


    const rejectNewBudget = async () => {
  if (!selectedNewBudget.value?.id) {
    showError("Please select a budget to reject");
    return;
  }

  spinner.value = 'rejecting';
  const payload = {
    status_id: 4,
    remark: remark.value,
    approved_by: JSON.parse(localStorage.getItem("user")).id
  };

  try {
    await axiosInstance.put(`budget-approvals/${selectedNewBudget.value.id}`, payload);
    showMessage("Budget Rejected");
    fetchSummary();
    getBudgetsApproval();
    selectedNewBudget.value = null;
    remark.value = '';
    rejection.value = false;
  } catch (error) {
    console.error(error);
    showError(error.message);
  } finally {
    spinner.value = '';
  }
};

const clearBudgetSelection = () => {
  selectedNewBudget.value = null;
  rejection.value = false;
  remark.value = '';
  amendmentItems.value = [];
};

     const user_permissions = JSON.parse(localStorage.getItem("user")).permissions;
     const summary = ref('')
     const showMessage = inject('showMessage');
     const showError = inject('showError');  
     const rowShimmer = inject('rowShimmer') ;
     const tableShimmer = inject('tableShimmer') ;
     const loadingSpinner = inject('loadingSpinner') ;
     const formatNumber = inject('formatNumber')
     const rejection = ref(false)
     const clearForm = () => {
      lpos.value = [];
      spinner.value = null;
      jobcards.value = []
      costNote.value = 'nothing'
     }
     const approveRequest = async (id) => {
      spinner.value = id;
      const payload = {
        status_name: 'Unapproved', 
        status_color: 'secondary',
      };
      try {
        const response = await axiosInstance.put(`purchase-orders/${id}`,payload);
        showMessage('Requisition approved successfully');
        getLpo('status_name=requisition');
        fetchSummary();
        spinner.value = null;
      } catch (error) {
        showError(error.message)
        console.error('Error approving requisition:', error);
        spinner.value = null;
      }
    }

    const fetchSummary = () => {
      axiosInstance.get('dashboard/summary')
        .then(response => {
          summary.value = response.data
        })
        .catch(error => {
          showError(error.message);
          console.error('Error fetching summary :', error);
        });
    };
    fetchSummary();
   
      
        const BudgetsApproval = ref([])
        const budgetColumns = ref(['Sno','project_name','budget','date_created','status','actions']);
        const selectedNewBudget = ref(null);
        const selectBudget = (budget) => {
          selectedNewBudget.value = budget;  // Update the selected budget
        };

     const getBudgetsApproval = async (statusFilter) => {
        loading.value = true;
        try {
        const response = await axiosInstance.get(`budget-approvals`);
        let filteredData = response.data;

    if (statusFilter === 'status_id=2') {
      filteredData = response.data.filter(item => item.status.name === 'Unapproved');
    }

    BudgetsApproval.value = filteredData.map((item, index) => ({
      ...item,
      Sno: index + 1,
      budget: item.budget?.name || 'N/A',
      project_name:item.budget?.project?.short_name,
      description: item.budget?.description || 'N/A',
      project: item.budget?.project_id || 'N/A',
      requester: item.user.name || 'N/A',
      date_created: new Date(item.created_at).toLocaleDateString(),
      status: {
        name: item.status?.name || 'N/A',
        color: item.status?.color || 'default',
      }
    }));
  } catch (error) {
    showError(error.message);
    console.log(error);
  } finally {
    loading.value = false;
  }
};

      const gdnItemColumns = ref(['Sno','item','description','requested','supplied','received']);
      const gdnItems = ref([])
      const selectedGdnId = ref(null);
     const fillGdn = (row)=>{
          selectedGdnId.value = row.id;
           gdnItems.value = row.items.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             description: item.gin_item.requisition_item.description,
             unit: item.unit,
             item : item.gin_item.requisition_item.remark,
             requested: item.gin_item.requisition_item.quantity,
             supplied: item.gin_item.quantity,
             received: item.quantity
            }))
        }
            const gdns = ref([])
           const gdnColumns = ref(['Sno','receiver','date_received','actions']);     
          const getGdns = async (id)=>{
          axiosInstance.get(`good-delivery-notes`)
        .then(response => {
            gdns.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             receiver : item.receiver.name,
             date_received: item.date_received
            }))
        })
        .catch(error => {
            console.error('Error fetching delivery note :', error);
        });
        }


        const ginItemColumns = ref(['Sno','item','requested','supplied']);
        const ginItems = ref([])
        const selectedGinId = ref(null);
        const fillGin = (row)=>{
          selectedGinId.value = row.id;
           ginItems.value = row.items.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             item: item.item_name,
             unit: item.unit,
             remark : item.remark,
             requested: item.requested,
             supplied: item.supplied,
            }))
        }


        const lpo_title = ref('Purchase Orders');
        const lpoColumns = ref(['Sno','order','date','project','supplier','payment','requester','total','awaits','approve']);
        const lpos = ref([])
        const getLpo = async (status)=>{
           if(status === 'status_name=requisition'){
            lpo_title.value = 'Requisitions';
           }else{
            lpo_title.value = 'Purchase Orders';
           }
          axiosInstance.get(`dashboard/lpos?${status}`)
        .then(response => {
            lpos.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             order: '00'+item.id,
             date:item.date_created,
             requester: item.requested_by,
             payment:item.payment_terms,
             total:item.total_amount.toLocaleString()+'/=',
             status:{
              name:item.status_name,
              color:item.status_color,
             }
            }))
        })
        .catch(error => {
          showError(error.message);
            console.error('Error fetching lpos :', error);
        });
        }
   

        const approvals = ref([])
        const approvalColumns = ref(['Sno','status','actions']);

        const approvalItems = ref([])

         const approval_title = ref('Purchase Orders');
              const getApprovals = async (group,status)=>{
           if(group === 1){
            approval_title.value = 'Purchase Order ';
           }else{
            approval_title.value = 'Purchase Orders';
           }
          axiosInstance.get(`dashboard/approvals?group_id=${group}&status_id=${status}`)
        .then(response => {
            approvals.value =response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             awaits: item.awaiting_approval.name,
             type: item.approval_group,
             requester: item.requester.name,
             date: item.date,
             status:{
              name:item.status.name,
              color:item.status.color,
             }
            }))
            console.log(approvals.value)
        })
        .catch(error => {
          showError(error.message);
            console.error('Error fetching lpos :', error);
        });
        }
        
        const grnColumns = ref(['Sno','grn','order','date','items','cost','select']);
        const grns = ref([])
        const grn_title = ref('GOOD RECEIVED NOTES RECORD')
        const getGrn = async (status)=>{
          loading.value = true
          if(status === 'filled'){
            grn_title.value = 'GOOD RECEIVED NOTES RECORD'
          }else{
            grn_title.value = 'UNRECEIVED GOODS RECORD'
          }
          axiosInstance.get(`good-received-notes?status=${status}`)
        .then(response => {
            grns.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             items: item.approval.items.length,
             cost: formatNumber(item.approval.items.reduce((total, i) => {
              return total + (parseFloat(i.quantity) * parseFloat(i.requisition_items.rate));
             }, 0)),
             grn: '00'+item.id,
             order :'00'+item.approval.id,
             date: new Date(item.approval.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }))
          loading.value = false
        })
        .catch(error => {
          showError(error.message)
            console.error( error);
            loading.value = false

        });
        }

        const jobcardColumns = ref(['Sno','jobcard','asset','type','service','date','status','actions']);
        const jobcards = ref([])
        const selectedJobcard = ref('')
        const getJobCards = async (id)=>{
          axiosInstance.get(`dashboard/jobcards?${id}`)
        .then(response => {
            jobcards.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             jobcard :'00'+ item.id,
             asset: item.machine.name,
             asset_id :item.machine.id,
             type: item.machine.type_name,
             service: item.service_type,
             date : item.date_created,
             status:{
              name:item.status.name,
              color:item.status.color,
             }
            }))
        })
        .catch(error => {
            console.error('Error fetching lpos :', error);
        });
        }

const costNote = ref('nothing')
const getCostNote = async (jobcard) =>{
  costNote.value = ''
   selectedJobcard.value = jobcard
    try {
        const response = await axiosInstance.get(`/cost-note-summary?jobcard_id=${jobcard.id}`);
        costNote.value = response.data
    } catch (error) {
          costNote.value = ''
         console.log(error)
        showError(error.message);
    }
}


        
        const selectedRequisition = ref('')
        const attachment = ref('')
        const generalTotal = ref(0)
        const requisitionItemColumns = ref(['Sno','description','spec','units','quantity','rate','total']);
        const requisitionItems = ref([])
        const requisition_status = ref('')
        const fillRequisition = (row)=>{
             requisition_status.value = row.status.name
             selectedRequisition.value = row.id
             attachment.value = row.attachment ? 'https://copex.trustdigital.space/'+row.attachment : null
             requisitionItems.value = row.items.map((item, index) => ({
             ...item,
             Sno: index + 1,
             description: item.remark,
             spec : item.description ?? '---',
             units : item.units ??'---',
             quantity : item.quantity,
             rate : Number(item.rate).toLocaleString() + '/=',
             total : Number(item.quantity * item.rate).toLocaleString()+'/=' 
             }))
            generalTotal.value = requisitionItems.value.reduce((sum, item) => {
              const qty = Number(item.quantity) || 0;
              const rate = Number(String(item.rate).replace(/[^\d.]/g, '')) || 0;
              return sum + qty * rate;
            }, 0);
        }


           const selectedApproval = ref('')
           const fillApproval = (row)=>{
            selectedApproval.value = row.approval_item_id
             approvalItems.value = row.items.map((item, index) => ({
             ...item,
             Sno: index + 1,
             description: item.requisition_items.remark ?? '---',
             spec : item.requisition_items.description ?? '---',
             units : item.requisition_items.units ??'---',
             quantity : item.requisition_items.quantity,
             rate : Number(item.requisition_items.rate).toLocaleString() + '/=',
             total : Number(item.requisition_items.quantity * item.requisition_items.rate).toLocaleString()+'/=' 
             }))
            generalTotal.value = requisitionItems.value.reduce((sum, item) => {
              const qty = Number(item.quantity) || 0;
              const rate = Number(String(item.rate).replace(/[^\d.]/g, '')) || 0;
              return sum + qty * rate;
            }, 0);
        }

        const requisitionsColumns = ref(['Sno','type','status','actions']);
        const requisitions = ref([])
        const getRequisitions = async (id)=>{
          loading.value = true
          try{
          const response = await axiosInstance.get(`dashboard/requisitions?${id}`)
                requisitions.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             requester: item.requester,
             type: item.type,
             date: item.date,
             status:{
              name:item.status,
              color:item.status_color,
             }
            }))
          }catch(error){
            showError(error.message)
            console.log(error)
          }finally{
            loading.value = false
          }
          
        }
            const gins = ref([])
           const ginColumns = ref(['Sno','issuer','date_issued','actions']);     
          const getGins = async (id)=>{
          axiosInstance.get(`dashboard/gins?${id}`)
        .then(response => {
            gins.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
    
             issuer : item.issuer.name,
             date_issued:  new Date(item.date_issued).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }),
             status:{
              name:item?.status?.name ?? 'Broken',
              color:item?.status?.color ?? 'danger',
             }
            }))
        })
        .catch(error => {
            console.error('Error fetching requisition :', error);
        });
        }

         const orders = ref([])
         const triggerOrder = (id, checked) => {
          if(orders.value.lenghth == 0){
            showMessage('No order')
          }
  if (checked) {
    if (!orders.value.includes(id)) {
      orders.value.push(id);
    }
  } else {
    orders.value = orders.value.filter(item => item !== id);
  }
};


    const spinner = ref('');
    const approveCheck = async (id, role) => {
      spinner.value = id;
        try {
            const response = await axiosInstance.put(`/approval-check/${id}`, {
                [role]: 1
            });
            getLpo();
            showMessage("Order approved successfully");
            spinner.value = '';
            // document.getElementById('close_lpo').click();
        } catch (error) {
            console.error("Error approving check:", error.message);
            showError("Failed to approve order");
            spinner.value = '';
        }
    };

        const approveUncheck = async (id, role,order_id) => {
      spinner.value = id;
        try {
            const response = await axiosInstance.put(`/approval-check/${id}`, {
                [role]: 0
            });
               await axiosInstance.put(`/purchase-order/${order_id}`, {
                status_name: "Unapproved",
                status_color:"secondary",
            });
            getLpo();
            spinner.value = '';
              showMessage("Order unapproved successfully");
        } catch (error) {
            console.error("Error approving check:", error.message);
            showError("Failed to Unapprove order");
            spinner.value = '';
        }
    };

    
</script>

<style>
body{
    background-color:white!important;
}
.card {
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  cursor:pointer;
}
</style>
